import addUserMarkupPopupEventListener from './addUserMarkupPopupEventListener';
import { ClientItem } from 'owa-mail-store';
import { UNMARK_ELEMENT_LABEL } from 'owa-mark/lib/utils/constants';
import markElements from 'owa-mark/lib/utils/markElements';

const styles = require('../components/UserMarkupStyles.scss');

export default function markUserNote(
    element: HTMLElement,
    item: ClientItem,
    selectedText: string,
    instance: number
) {
    markElements(
        element,
        [selectedText],
        (keyword: string) => (matchedElement: HTMLElement, count: number) => {
            if (count == instance) {
                markInstanceOfUserNote(matchedElement, item, keyword, instance);
            } else {
                matchedElement.classList.add(UNMARK_ELEMENT_LABEL);
            }
        },
        false /* useRegExp */,
        'partially' /* accuracy */
    );
}

export function markInstanceOfUserNote(
    element: HTMLElement,
    item: ClientItem,
    selectedText: string,
    instance: number
) {
    // Highlight selection in theme color
    element.classList.add(styles.userNote);

    // Show UserNotePopup on hover
    addUserMarkupPopupEventListener(
        element,
        item,
        selectedText,
        true /* isForExistingUserNote */,
        instance
    );
}
